import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
// import {NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import {FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import {NgxPaginationModule} from 'ngx-pagination';
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import { environment } from "src/environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFireFunctionsModule } from "@angular/fire/functions";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireAuthModule } from "@angular/fire/auth";
import {
  AngularFireStorageModule,
  AngularFireStorageReference,
  AngularFireUploadTask,
} from "@angular/fire/storage";
import {AngularFireAnalytics, AngularFireAnalyticsModule} from '@angular/fire/analytics';
import {AuthService} from "./shared/services/auth.service";
import { NgAisModule } from 'angular-instantsearch';


  // ANGULAR MATERIAL
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {TextFieldModule} from '@angular/cdk/text-field'
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatBadgeModule} from '@angular/material/badge';
import {MatExpansionModule} from '@angular/material/expansion';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatMenuModule} from '@angular/material/menu';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatStepperModule} from '@angular/material/stepper';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatTreeModule} from '@angular/material/tree';
import {CdkTreeModule} from '@angular/cdk/tree';

// responsive
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BuscarComponent } from './components/visitantes/buscar/buscar.component';
import { DetalleCursoComponent } from './components/visitantes/detalle-curso/detalle-curso.component';
import { DetalleEmpresasComponent } from './components/visitantes/detalle-empresas/detalle-empresas.component';
import { DetalleInstructorComponent } from './components/visitantes/detalle-instructor/detalle-instructor.component';
import { FormInstructorComponent } from './components/admin/instructores/form-instructor/form-instructor.component';
import { FormEmpresasComponent } from './components/admin/empresas/form-empresas/form-empresas.component';
import { ListaEmpresasComponent } from './components/admin/empresas/lista-empresas/lista-empresas.component';
import { InicioComponent } from './components/visitantes/inicio/inicio.component';
import { SignInComponent } from './components/autenticacion/sign-in/sign-in.component';
import { SignInForgotPasswordComponent } from './components/autenticacion/sign-in-forgot-password/sign-in-forgot-password.component';
import { SignInVerifyEmailComponent } from './components/autenticacion/sign-in-verify-email/sign-in-verify-email.component';
import { SignUpComponent } from './components/autenticacion/sign-up/sign-up.component';
import { FirebaseService } from './shared/services/firebase.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MiCuentaEstudianteComponent } from './components/estudiante/mi-cuenta-estudiante/mi-cuenta-estudiante.component';
import { FooterComponent } from './components/app-base/footer/footer.component';
import { ListaCursosComponent } from './components/admin/cursos/lista-cursos/lista-cursos.component';
import { MisCursosComponent } from './components/estudiante/mis-cursos/mis-cursos.component';
import { DetalleCursoCompradoComponent } from './components/estudiante/detalle-curso-comprado/detalle-curso-comprado.component';
import { ComprarCursoComponent } from './components/estudiante/comprar-curso/comprar-curso.component';
import { AdminComponent } from './components/admin/admins/admin/admin.component';
import { ModuloComponent } from './components/estudiante/modulo/modulo.component';
import { MenuComponent } from './components/app-base/menu/menu.component';
import { CertificadoComponent } from './components/visitantes/certificado/certificado.component';
import { PagosComponent } from './components/admin/ventas/pagos/pagos.component';
import { PoliticaPrivacidadComponent } from './components/informativas/politica-privacidad/politica-privacidad.component';
import { TerminosCondicionesComponent } from './components/informativas/terminos-condiciones/terminos-condiciones.component';
import { SoporteComponent } from './components/informativas/soporte/soporte.component';
import { SoporteChatAdminComponent } from './components/admin/soporte-chat-admin/soporte-chat-admin.component';
import { CapacitacionEmpresasComponent } from './components/informativas/capacitacion-empresas/capacitacion-empresas.component';
import { EnsenaComponent } from './components/informativas/ensena/ensena.component';
import { ListaInstructoresComponent } from './components/admin/instructores/lista-instructores/lista-instructores.component';
import { ResumenInstructorComponent } from './components/instructor/resumen-instructor/resumen-instructor.component';
import { UserRolesComponent } from './components/admin/admins/user-roles/user-roles.component';
import { CuestionarioComponent } from './components/estudiante/cuestionario/cuestionario.component';
import { ValorarCursoComponent } from './components/estudiante/valorar-curso/valorar-curso.component';
import { SincronizarProgresosComponent } from './components/admin/cursos/sincronizar-progresos/sincronizar-progresos.component'; 
import { UploadService } from './shared/services/upload.service';
import { DashboardAdminEmpresaComponent } from './components/admin/empresas-cliente/dashboard-admin-empresa/dashboard-admin-empresa.component';
import { ResultadoCuestionarioComponent } from './components/estudiante/resultado-cuestionario/resultado-cuestionario.component';
import { SpinnerComponent } from './components/app-base/spinner/spinner.component';
import { MiniSpinnerComponent } from './components/app-base/mini-spinner/mini-spinner.component';
import { EditarCursoInfoComponent } from './components/admin/cursos/editar-curso-info/editar-curso-info.component';
import { EditarCursoSesionesComponent } from './components//admin/cursos/editar-curso-sesiones/editar-curso-sesiones.component';
import { EditarCursoExamenComponent } from './components/admin/cursos/editar-curso-examen/editar-curso-examen.component';
import { EditarCursoComponent } from './components/admin/cursos/editar-curso/editar-curso.component'; 
import { ResetPasswordComponent } from './components/autenticacion/reset-password/reset-password.component';
import { ListaAdminsComponent } from './components/admin/admins/lista-admins/lista-admins.component';
import { ListaEmpresasClienteComponent } from './components/admin/empresas-cliente/lista-empresas-cliente/lista-empresas-cliente.component';
import { ListaEstudiantesComponent } from './components/admin/estudiantes/lista-estudiantes/lista-estudiantes.component';
import { ListaCategoriasComponent } from './components/admin/lista-categorias/lista-categorias.component';
import { RegistrarPagosComponent } from './components/admin/ventas/registrar-pagos/registrar-pagos.component';
import { VentasComponent } from './components/admin/ventas/ventas/ventas.component';
import { ResumenAdminComponent } from './components/admin/resumen-admin/resumen-admin.component';
import { MenuVerticalComponent } from './components/app-base/menu-vertical/menu-vertical.component';
import { FormEmpresaClienteComponent } from './components/admin/empresas-cliente/form-empresa-cliente/form-empresa-cliente.component';
import { DialogConfirmarComponent } from './components/app-base/dialogs/confirmar/dialog-confirmar.component';
import { ExitoComponent } from './components/app-base/dialogs/exito/exito.component';
import { FracasoComponent } from './components/app-base/dialogs/fracaso/fracaso.component';
import { DetalleTransaccionComponent } from './components/admin/ventas/detalle-transaccion/detalle-transaccion.component';
import { DetallePagoComponent } from './components/admin/ventas/detalle-pago/detalle-pago.component';
import { HistorialComprasEstudianteComponent } from './components/estudiante/historial-compras-estudiante/historial-compras-estudiante.component';
import { SignInInstructorComponent } from './components/autenticacion/sign-in-instructor/sign-in-instructor.component';
import { EstComponent } from './components/estudiante/est/est.component';
import { InstComponent } from './components/instructor/inst/inst.component';
import { SignUpInstructorComponent } from './components/admin/instructor/sign-up-instructor/sign-up-instructor.component';
import { FAQComponent } from './components/informativas/faq/faq.component';
import { DatosFacturacionEstudianteComponent } from './components/estudiante/datos-facturacion-estudiante/datos-facturacion-estudiante.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HtmlEditorComponent } from './components/admin/cursos/html-editor/html-editor.component';
import { ChatSoporteComponent } from './components/visitantes/chat-soporte/chat-soporte.component';
import { VentaManualComponent } from './components/admin/ventas/venta-manual/venta-manual.component';
import { PdfViewerModule} from "ng2-pdf-viewer";
import { PoliticaCookiesComponent } from './components/informativas/politica-cookies/politica-cookies.component';
import { SSRExcludeModule } from 'ngx-ssr-exclude';
import { DetalleFacturaComponent } from './components/admin/detalle-factura/detalle-factura.component';

@NgModule({
  declarations: [
    AppComponent,
    BuscarComponent,
    DetalleCursoComponent,
    DetalleEmpresasComponent,
    DetalleInstructorComponent,
    FormInstructorComponent,
    FormEmpresasComponent,
    ListaEmpresasComponent,
    InicioComponent,
    SignInComponent,
    SignInForgotPasswordComponent,
    SignInVerifyEmailComponent,
    SignUpComponent,
    MiCuentaEstudianteComponent,
    FooterComponent,
    ListaCursosComponent,
    MisCursosComponent,
    DetalleCursoCompradoComponent,
    ComprarCursoComponent,
    AdminComponent,
    ModuloComponent,
    MenuComponent,
    CertificadoComponent,
    PagosComponent,
    PoliticaPrivacidadComponent,
    TerminosCondicionesComponent,
    SoporteComponent,
    CapacitacionEmpresasComponent,
    EnsenaComponent,
    ListaInstructoresComponent,
    ResumenInstructorComponent,
    UserRolesComponent,
    CuestionarioComponent,
    ValorarCursoComponent,
    SincronizarProgresosComponent,
    DashboardAdminEmpresaComponent,
    ResultadoCuestionarioComponent,
    SpinnerComponent,
    MiniSpinnerComponent,
    EditarCursoInfoComponent,
    EditarCursoSesionesComponent,
    EditarCursoExamenComponent,
    EditarCursoComponent,
    ResetPasswordComponent,
    ListaAdminsComponent,
    ListaEmpresasClienteComponent,
    ListaEstudiantesComponent,
    ListaCategoriasComponent,
    RegistrarPagosComponent,
    VentasComponent,
    ResumenAdminComponent,
    MenuVerticalComponent,
    FormEmpresaClienteComponent,
    DialogConfirmarComponent,
    ExitoComponent,
    FracasoComponent,
    DetalleTransaccionComponent,
    DetallePagoComponent,
    HistorialComprasEstudianteComponent,
    SignInInstructorComponent,
    EstComponent,
    InstComponent,
    SignUpInstructorComponent,
    FAQComponent,
    DatosFacturacionEstudianteComponent,
    HtmlEditorComponent,
    ChatSoporteComponent,
    SoporteChatAdminComponent,
    VentaManualComponent,
    PoliticaCookiesComponent,
    DetalleFacturaComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AngularEditorModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    AngularFireAnalyticsModule,
    NgAisModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    DragDropModule,
    MatFormFieldModule,
    MatInputModule,
    TextFieldModule,
    MatIconModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    FlexLayoutModule,
    MatSnackBarModule,
    MatTabsModule,
    MatBadgeModule,
    MatExpansionModule,
    ClipboardModule,
    HttpClientModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatRadioModule,
    MatSliderModule,
    MatListModule,
    MatTooltipModule,
    MatStepperModule,
    DragDropModule,
    MatTreeModule,
    CdkTreeModule,
    PdfViewerModule,
    SSRExcludeModule,
  ],
  providers: [AuthService,FirebaseService, UploadService,],
  bootstrap: [AppComponent]
})
export class AppModule { }
